import useWindowWidth from '../useWindowWidth'

export enum Breakpoint {
  Xs = 320,
  Sm = 540,
  Md = 768,
  Lg = 1024,
  Xl = 1920,
  Xxl = 2560,
}

interface UseBreakpointProps {
  maxBreakpoint?: Breakpoint
  minBreakpoint?: Breakpoint
}
const useBreakpoint = ({ minBreakpoint, maxBreakpoint }: UseBreakpointProps) => {
  const width = useWindowWidth()

  return (
    (!minBreakpoint?.valueOf() || width > minBreakpoint.valueOf()) &&
    (!maxBreakpoint || width < maxBreakpoint.valueOf())
  )
}

export default useBreakpoint
